module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('VHeader'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    staticClass: "view"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spc4footer"
  })], 1), _vm._v(" "), _c('VFooter'), _vm._v(" "), _c('div', {
    staticClass: "cover"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f84f049!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Main.vue
// module id = 112
// module chunks = 2